export default __webpack_public_path__ + "static/media/left_arrow_disabled_icon.4575c95e.svg";